import { render, staticRenderFns } from "./index-原料区道闸.vue?vue&type=template&id=2beccf60&scoped=true&"
import script from "./index-原料区道闸.vue?vue&type=script&lang=js&"
export * from "./index-原料区道闸.vue?vue&type=script&lang=js&"
import style0 from "./index-原料区道闸.vue?vue&type=style&index=0&id=2beccf60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beccf60",
  null
  
)

export default component.exports